import React from "react";
import axe from "../img/axe.png";
import sword from "../img/sword.png";
import pickaxe from "../img/pickaxe.png";
import skin1 from "../img/skin1.png";
import skin2 from "../img/skin2.png";
import skin3 from "../img/skin3.png";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";

function ShopDiscord({ shop }) {

  const {inView , ref} = useInView()

  return (
    <section ref={ref} className={`${shop? 'shop-background' : 'discord-background'}`} id={`${shop? 'shop' : 'discord'}`}>
      <div className="container">
        <h3 className="section-title">{shop ? "Shop" : "Discord"}</h3>
        <div className="shop">
          {!shop && (
            <div className="shop--img">
              <img src={skin1} className={`${inView && "skin"}`} />
              <img src={skin2} className={`${inView && "skin"}`} />
              <img src={skin3} className={`${inView && "skin"}`} />
            </div>
          )}
          <div className={`${inView&& "shop--content"}`}>
            <h2 className="content-title">
              {shop ? "Want to be special?" : "Join our community"}
            </h2>
            <p className="shop--content__description">
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Est
              nobis maiores dolorem asperiores fuga molestiae eaque perferendis
              laborum quo laudantium unde, quos quam totam eligendi impedit
              itaque labore voluptatem aspernatur.
            </p>
            <Link to='https://google.com'>
              <button className="content--button btn">
                {shop? 'Shop Now' : "Join Now"}
              </button>
            </Link>
          </div>
          {shop && (
            <div className="shop--img">
              <img src={pickaxe} className={`${inView && "shop--img__item"}`} />
              <img src={axe} className={`${inView && "shop--img__item"}`} />
              <img src={sword} className={`${inView && "shop--img__item"}`} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default ShopDiscord;
